import { ITeam } from 'pages/UserManagement/UserManagementCreate/UserManagementGeneralForm/UserManagementGeneralForm.models';
import { teamsPath } from 'core/api/constants';
import { netsparkAxios } from 'core/services/HTTPService';

export const getTeams = () => netsparkAxios.get<ITeam[]>(teamsPath);

export default { getTeams };
